export default {
  apiDomain: "https://quiet-hamlet-94505.herokuapp.com/api/",
  dbConn: ""
};
